/**
 * Envoltorio presentacional de tabla. La ordenación y la paginación siguen
 * viniendo de @tanstack/react-table, que ya está en el proyecto — no las
 * reescribas.
 *
 * IMPRESCINDIBLE el par `overflow-x:auto` + `minWidth`: sin él se pierden
 * columnas en pantallas angostas, sin scroll para alcanzarlas. Mínimos
 * medidos: Órdenes 1320 · Usuarios 1560 · Alertas 900 · Ciudades 560 ·
 * Países del producto 660.
 *
 * NOTA: el proyecto tiene DOS librerías de tabla instaladas
 * (react-data-table-component y @tanstack/react-table). Unificar en
 * @tanstack es parte del trabajo — ver README, Advertencia 3.
 */
export const DataTableShell = ({
  filters,
  groups,
  headers,
  children,
  minWidth,
  footer,
  empty = false,
  emptyMessage = 'No hay registros para mostrar.',
}) => (
  <div className="ui-table-card">
    {filters && <div className="ui-table-card__filters">{filters}</div>}

    <div className="ui-table-scroll">
      <table className="ui-table" style={{ minWidth }}>
        <thead>
          {groups && (
            <tr className="ui-table__groups">
              {groups.map((g) => (
                <th key={g.label} colSpan={g.span}>{g.label}</th>
              ))}
            </tr>
          )}
          <tr className="ui-table__head">{headers}</tr>
        </thead>
        <tbody>
          {empty ? (
            <tr>
              <td className="ui-table__empty" colSpan={99}>
                <i className="ri-inbox-line" />
                <span>{emptyMessage}</span>
              </td>
            </tr>
          ) : children}
        </tbody>
      </table>
    </div>

    {footer && <div className="ui-table-card__footer">{footer}</div>}
  </div>
);

export default DataTableShell;
